import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { HelmetProvider } from 'react-helmet-async';

// Components
import Header from "./components/Header";
import Footer from "./components/Footer";
import SimpleLPFooter from "./components/SimpleLPFooter";
import UniversalPopup from "./components/UniversalPopup";

// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import LandingPage from "./pages/LandingPage";
import TrademarkRegistrationLP from "./pages/TrademarkRegistrationLP";
import ServicePage from "./pages/ServicePage";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const openPopup = () => setIsPopupOpen(true);
  const closePopup = () => setIsPopupOpen(false);

  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
          {/* Landing Page Routes - Special header/footer */}
          <Route 
            path="/lp" 
            element={
              <>
                <Header onOpenPopup={openPopup} isLandingPage={true} />
                <LandingPage onOpenPopup={openPopup} />
                <SimpleLPFooter />
              </>
            } 
          />
          
          {/* New Trademark Registration Landing Page */}
          <Route 
            path="/lp/trademark-registration" 
            element={
              <>
                <Header onOpenPopup={openPopup} isLandingPage={true} />
                <TrademarkRegistrationLP onOpenPopup={openPopup} />
                <SimpleLPFooter />
              </>
            } 
          />

          {/* Main Website Routes - Normal header/footer */}
          <Route 
            path="/" 
            element={
              <>
                <Header onOpenPopup={openPopup} />
                <Home onOpenPopup={openPopup} />
                <Footer />
              </>
            } 
          />
          
          <Route 
            path="/about" 
            element={
              <>
                <Header onOpenPopup={openPopup} />
                <About onOpenPopup={openPopup} />
                <Footer />
              </>
            } 
          />
          
          <Route 
            path="/contact" 
            element={
              <>
                <Header onOpenPopup={openPopup} />
                <Contact />
                <Footer />
              </>
            } 
          />
          
          <Route 
            path="/privacy" 
            element={
              <>
                <Header onOpenPopup={openPopup} />
                <Privacy />
                <Footer />
              </>
            } 
          />
          
          <Route 
            path="/terms" 
            element={
              <>
                <Header onOpenPopup={openPopup} />
                <Terms />
                <Footer />
              </>
            } 
          />
          
          {/* Service Pages - Dynamic routing */}
          <Route 
            path="/services/:serviceId" 
            element={
              <>
                <Header onOpenPopup={openPopup} />
                <ServicePage onOpenPopup={openPopup} />
                <Footer />
              </>
            } 
          />
        </Routes>

        {/* Universal Popup */}
        <UniversalPopup isOpen={isPopupOpen} onClose={closePopup} />
        
        {/* Toast Notifications */}
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
